/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Form, Input, Icon, Button, Spin, message } from 'antd';
import { useState } from 'react';
import { useAuth } from '~context/authContext';

const LoginForm = ({ form }) => {
  const { getFieldDecorator, validateFields } = form;
  const [isLoading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = event => {
    event.preventDefault();
    validateFields((validateErr, values) => {
      if (!validateErr) {
        setLoading(true);
        login(values).catch(() => {
          setLoading(false);
          message.error('Invalid credentials, please try again');
        });
      }
    });
  };

  const formStyle = css`
    width: 16rem;
  `;

  const formButtonStyle = css`
    width: 60%;
  `;

  const inputStyle = css`
    color: rgba(0, 0, 0, 0.25);
  `;

  return (
    <Spin spinning={isLoading} delay={500}>
      <Form onSubmit={handleSubmit} css={formStyle}>
        <Form.Item>
          {getFieldDecorator('username', {
            rules: [{ required: true, whitespace: true, message: 'Username is required' }],
          })(<Input css={inputStyle} prefix={<Icon type="user" />} placeholder="Username" />)}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Password is required' }],
          })(
            <Input.Password
              css={inputStyle}
              prefix={<Icon type="lock" />}
              type="password"
              placeholder="Password"
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" css={formButtonStyle}>
            Log in
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default Form.create({ name: 'login' })(LoginForm);
